import script from "./LearningSpaceNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./LearningSpaceNav.vue?vue&type=script&setup=true&lang=ts"

import "./LearningSpaceNav.vue?vue&type=style&index=0&id=b4881aa0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4881aa0"]])

export default __exports__